import type { PropsWithChildren } from 'react';
import React from 'react';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import type { WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import st from './BaseEventPreview.module.sass';

export interface BaseEventPreviewProps extends PropsWithChildren, WithDataTestid {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isAlarm?: boolean;
  isActive?: boolean;
}

function Main({ children }: PropsWithChildren): React.JSX.Element {
  return (
    <div className={st.Main}>
      {children}
    </div>
  );
}

function Media({ children }: PropsWithChildren): React.JSX.Element {
  return (
    <div className={st.Media}>
      {children}
    </div>
  );
}

function Info({ children }: PropsWithChildren): React.JSX.Element {
  return (
    <div className={st.Info}>
      {children}
    </div>
  );
}

function Footer({ children }: PropsWithChildren): React.JSX.Element {
  return (
    <div className={st.Footer}>
      {children}
    </div>
  );
}

const displayName = 'BaseEventPreview';
const testid = buildTestid(displayName);

export function BaseEventPreview({
  children,
  'data-testid': dataTestId = undefined,
  onClick,
  isAlarm = false,
  isActive = false,
}: BaseEventPreviewProps): React.JSX.Element {
  return (
    <article
      className={cn(st.Root, {
        [st.Root_active]: isActive,
        [st.Root_alarm]: isAlarm,
      })}
      {...testid(dataTestId)}
    >
      <button
        aria-label="Select card"
        className={st.CardButton}
        onClick={onClick}
        type="button"
      />

      <div className={st.Content}>
        {children}
      </div>
    </article>
  );
}

BaseEventPreview.Main = Main;
BaseEventPreview.Media = Media;
BaseEventPreview.Info = Info;
BaseEventPreview.Footer = Footer;
